module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination-container",
    attrs: {
      "id": "pagination-template"
    }
  }, [_c('ul', {
    staticClass: "pagination pc-only",
    class: _vm.isPc ? 'pc-only' : 'mo-only'
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage < _vm.size
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "첫 페이지"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goFirst.apply(null, arguments)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage <= 1
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "이전 페이지"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goPrev.apply(null, arguments)
      }
    }
  }, [_vm._v("‹")])]), _vm._v(" "), _vm._l((_vm.pageRange(_vm.minPage, _vm.maxPage)), function(page) {
    return _c('li', {
      key: page,
      staticClass: "page-item",
      class: {
        active: page === _vm.currentPage
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#",
        "title": "{{ page }} 페이지"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.transParentPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage >= _vm.maxPage
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "다음 페이지"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNext.apply(null, arguments)
      }
    }
  }, [_vm._v("›")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage >= _vm.maxPage - _vm.size
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "마지막 페이지"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goLast.apply(null, arguments)
      }
    }
  }, [_vm._v("»")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8a5dc9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/shared/Pagination.vue
// module id = 1345
// module chunks = 6